import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [status, setStatus] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!password || !confirmPassword) {
      return setStatus("Both fields are required.");
    }
    if (password !== confirmPassword) {
      return setStatus("Passwords do not match.");
    }

    try {
      await axios.post("https://api.egosaferelationship.com/users/reset-password", {
        token,
        newPassword: password,
      });
      setStatus("✅ Password successfully reset.");
    } catch (err) {
      setStatus(err.response?.data?.error || "❌ Something went wrong.");
    }
  };

  return (
    <div style={{ margin: "60px", fontFamily: "Arial" }}>
      <h2>SECOND CHANCE</h2>
      <h2>Reset Your Password</h2>
      <form onSubmit={handleSubmit} style={{ maxWidth: "400px" }}>
        <div>
          <label>New Password:</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            style={{ width: "100%", marginBottom: "10px" }}
          />
        </div>
        <div>
          <label>Confirm Password:</label>
          <input
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
            style={{ width: "100%", marginBottom: "20px" }}
          />
        </div>
        <button type="submit">Reset Password</button>
      </form>
      {status && (
        <p style={{ marginTop: "10px", color: "crimson" }}>{status}</p>
      )}
    </div>
  );
};

export default ResetPassword;
